import React from "react";
import {Link} from "react-router-dom";

export default function Footer() {
  	return (
	   <footer id="footer">
			<div className="wrapper">
				<div style={{marginRight: "10vw", marginLeft: "5vw"}}>
					<div className="row clearfix"  style={{ maxHeight: "3vh"}}>
						<div className="col-3">
							<div style={{margin: "auto", maxHeight: "3vh"}}>
								<a href="https://www.idecisionsciences.com/" target="_blank" rel="noreferrer">
									<div className="image-block-wrapper">
										<img style={{top: "0%", left: "0%", height: "50px", width: "180px"}} src="images/ids_logo.png" alt=""/>
									</div>
								</a>
							</div>
					</div>
					<div className="col-7">
					<p className="text-start">
					<em>
					This website is maintained by <a href="https://www.idecisionsciences.com/" target="_blank" rel="noreferrer">iDecisionSciences.</a>
					</em><br/>All rights reserved.<br/>View <Link to="/terms">Terms of service</Link>.
					</p>
					</div>
					<div className="col-2">
						<a href="https://twitter.com/iDecisionSci" target="_blank" rel="noreferrer">
						<span class="fa fa-x-twitter"></span>
						</a>
					</div>
				</div>
			</div>
		</div>
	</footer>
	);
}
